import React, { useContext, useMemo } from 'react';
import { PopoverContextType, PopoverProviderProps } from 'components';

const PopoverContext = React.createContext<PopoverContextType | undefined>(
  undefined,
);

export const PopoverProvider: React.FC<PopoverProviderProps> = ({
  arrow,
  arrowRef,
  arrowStyle,
  children,
  isOpen,
  popoverAttributes,
  popoverRef,
  popoverStyle,
}) => (
  <PopoverContext.Provider
    value={useMemo(
      () => ({
        arrow,
        arrowRef,
        arrowStyle,
        isOpen,
        popoverAttributes,
        popoverRef,
        popoverStyle,
      }),
      [
        arrow,
        arrowStyle,
        isOpen,
        popoverAttributes,
        popoverRef,
        popoverStyle,
        arrowRef,
      ],
    )}
  >
    {children}
  </PopoverContext.Provider>
);

export function usePopover() {
  const context = useContext(PopoverContext);

  if (context === undefined) {
    throw new Error('usePopover must be used within PopoverProvider');
  }

  return context;
}
